module.exports = __webpack_public_path__ + "src/images/measurements/bustSpan.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/bustSpan.png
// module id = 1143
// module chunks = 0